import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DigitalSopService } from 'src/app/services/digital-sop.service';

@Component({
  selector: 'app-digital-sop-organism',
  templateUrl: './digital-sop-organism.component.html',
  styleUrls: ['./digital-sop-organism.component.scss']
})
export class DigitalSopOrganismComponent {
  heading: string = "Digital Standard Operating Procedures";
  helpText: string = "Manage and access your digital SOPs";
  sopList: any[] = [];
  activeIndex: any = null;
  renderSop = true;
  formData;
  searchText: string = '';
  searchSopSubject = new Subject<string>();
  isCollapsed = false;

  constructor(private digitalSopService: DigitalSopService, private snack: MatSnackBar) { }
  ngOnInit(): void {
    this.activeIndex = null;
    this.loadSops();
    this.searchSopSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.fetchSopList(searchTerm);
    });
  }

  loadSops(): void {
    this.activeIndex = null;
    this.digitalSopService.getSopList().subscribe((items: any) => {
      this.sopList = items;
      this.formData = this.sopList.length > 0 ? this.sopList[this.activeIndex] : null;
    })
  }
  handleItemClick(item, index) {
    this.activeIndex = index;
    this.formData = item;
    this.isCollapsed = true;
    // delete this.formData;
    this.reloadSop();
    // setTimeout(() => {
    //   this.formData = item;
    // }, 0)
  }
  reloadSop() {
    this.renderSop = false;
    setTimeout(() => this.renderSop = true, 0);
  }
  createNewSop(): void {
    this.formData = {};
    this.activeIndex = null;
    this.reloadSop()
  }
  onSopUpdated(id): void {
    if (id === null) {
      this.loadSops();
      this.handleItemClick({}, null)
    } else {
      this.digitalSopService.getSopList().subscribe((res: Array<any>) => {
        this.sopList = res;
        const requiredSop = this.sopList.find(item => item.id === id);
        this.activeIndex = requiredSop ? this.sopList.indexOf(requiredSop) : 0;
        this.handleItemClick(requiredSop, this.activeIndex);
      });
    }
  }
  showSnackbar(message: string) {
    this.snack.open(message, 'close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  onSearchInputChange() {
    this.searchSopSubject.next(this.searchText);
  }
  clearSearch() {
    this.searchText = '';
    this.loadSops();
    this.handleItemClick({}, null)
  }
  fetchSopList(query: string) {
    if (query.trim()) {
      this.digitalSopService.searchSopList(query).subscribe((res: any) => {
        this.sopList = res;
        this.activeIndex = 0;
        this.formData = res[0];
        this.reloadSop();
      }, (error) => {
        this.showSnackbar('Error while fetching the list')
      });
    }
  }
  toggleLeftColumn() {
    this.isCollapsed = !this.isCollapsed;
  }
}
